import React from 'react';
import { Typography, Box, Container, Button } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import { ActivePropertiesActions } from './ActivePropertiesActions';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const PropertiesBatchActions = observer(_ref => {
  let triggerRefresh = _ref.triggerRefresh;
  const store = useStore();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.batchBarWrapper
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.batchBarContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selectInfo
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    size: "small",
    onClick: () => store.portfoliosMultiActionStore.deselectAll(),
    'custom-attribute': '751-properties-batch-actions'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.selectCount
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, store.portfoliosMultiActionStore.selectedItems.length, /*#__PURE__*/React.createElement("span", null, store.portfoliosMultiActionStore.selectedItems.length > 1 ? ' items selected' : ' item selected')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, "You can continue to select multiply lines to process batch actions."))), /*#__PURE__*/React.createElement(ActivePropertiesActions, {
    triggerRefresh: triggerRefresh
  }))));
});